import React from "react";

const OtherCombinations = ({ unit, combinations, isOtherCombinations }) => {
  const hasOrificeDisc = combinations.some(
    (c) =>
      c.orificeDiscSize !== undefined &&
      c.orificeDiscSize !== null &&
      c.orificeDiscSize !== ""
  );

  return (
    <div className="other-comb">
      <h2>
        {isOtherCombinations
          ? "Other combinations that produce similar results"
          : "Possible combinations that produce similar results"}
      </h2>

      <div className="comb-table">
        <div className="table-header">
          {hasOrificeDisc && (
            <div className="header-wrap highlighted">
              <h3>ORIFICE DISC SIZE</h3>
            </div>
          )}
          <div className="header-wrap highlighted">
            <h3>SWIRL TYPE</h3>
          </div>
          <div className="header-wrap">
            <h3>FLOW RATE ({unit === "metric" ? "L/hr" : "gal/min"})</h3>
          </div>
          <div className="header-wrap">
            <h3>DROPLET SIZE (μm D32)</h3>
          </div>
          <div className="header-wrap">
            <h3>
              ANGLE at {unit === "metric" ? "69 bar" : "1000 psi"}
            </h3>
          </div>
        </div>

        <div className="table-content">
          {combinations.map((combo, i) => (
            <div className="table-row" key={i}>
              {hasOrificeDisc && (
                <div className="result-container highlighted">
                  <div className="result">
                    {combo.orificeDiscSize ? combo.orificeDiscSize : "-"}
                  </div>
                </div>
              )}
              <div className="result-container highlighted">
                <div className="result">{combo.swirlType}</div>
              </div>
              <div className="result-container">
                <div className="result">{combo.flowRate}</div>
              </div>
              <div className="result-container">
                <div className="result">{combo.dropletSize}</div>
              </div>
              <div className="result-container">
                <div className="result">{combo.angle}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OtherCombinations;
